export const DispatchInput = {
  updated() {
    // Dispatch with bubbles: false to prevent event misrouting to wrong LiveComponents.
    // The input is already inside the target form, so bubbling is unnecessary.
    // This prevents issues similar to ENA-7671 where stale CID references cause
    // UndefinedFunctionError when events route to unmounted/remounted components.
    //
    // Setting this back to `true` because of ENA-8060
    this.el.dispatchEvent(new Event("input", { bubbles: true }))
  },
}
